import React from 'react';
import { useParams } from 'react-router-dom';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import {
  EqualisationSection,
  FeesEqualisationTreatment,
} from 'further-types/lp/equalisation';
import FormWrapper, { EqualisationFeesFormValues } from './FormWrapper';
import EqualiseFeesContent from './EqualiseFeesContent';

const EqualiseFees: React.FC<{ baseCurrency: CurrencyCode }> = ({
  baseCurrency,
}) => {
  const { id } = useParams<{ id?: string }>();
  const { selectedVehicleId } = useLayoutContext();

  const [lpFeeTemplates] = api.lpFeeTemplate.list.useSuspenseQuery({
    vehicleId: selectedVehicleId ?? '',
  });
  const [equalisationCommitmentsWithFees] =
    api.equalisations.getEqualisationFees.useSuspenseQuery({
      equalisationId: id ?? '',
      vehicleId: selectedVehicleId ?? '',
      feeTemplateOverrides: [],
    });

  const formValues: EqualisationFeesFormValues = {
    totalCommitmentFees: equalisationCommitmentsWithFees.map((commitment) => ({
      commitmentId: commitment.commitmentId,
      investorName: commitment.investorName,
      investorStatus: commitment.investorStatus,
      totalEqualisationFeeIncTaxLcy: commitment.totalEqualisationFeeIncTaxLcy,
      lpFeeTemplateId: commitment.lpFeeTemplateId ?? 'none',
      feesEqualisationTreatment:
        commitment.feesEqualisationTreatment ?? FeesEqualisationTreatment.None,
      feesEqualisationTreatmentPercentage:
        commitment.feesEqualisationTreatmentPercentage,
      lpFees:
        commitment.lpFeesByTemplate[commitment.lpFeeTemplateId ?? '']?.lpFees ??
        [],
      lpFeesByTemplate: commitment.lpFeesByTemplate,
    })),
  };

  return (
    <FormWrapper key={EqualisationSection.ManagementFees} values={formValues}>
      <EqualiseFeesContent
        lpFeeTemplates={lpFeeTemplates}
        baseCurrency={baseCurrency}
      />
    </FormWrapper>
  );
};

export default EqualiseFees;
